const SpecialistsServicesComponent = {
    data() {
        return {
            specialists: [],
            loading: false,
            swiper: null,

            /**
             * Группы услуг (для табов)
             */
            groups: [],

            /**
             * Чтобы не навешивать обработчики табов повторно
             */
            tabsInited: false,

            baseUrl: window.appConfig?.baseUrl || '',
            plugImage: window.appConfig?.specialistsPlug || '/img/plug.jpg',
        };
    },

    methods: {
        async getSpecialists() {
            this.loading = true;

            try {
                /**
                 * 1) Специалисты
                 */
                const response = await window.specialistService.getSpecialists({limit: 100, page: 1});
                this.specialists = response?.data ?? [];

                this.specialists = (Array.isArray(response?.data) ? response.data : []).map(row => {
                    const professions = Array.isArray(row?.professions) ? row.professions : []
                    const profession_ids = Array.isArray(row?.profession_ids) ? row.profession_ids : []
                    const id = Number(row?.id || 0) || 0
                    const pid = Number(profession_ids[0] || 0) || 0

                    return {
                        ...row,
                        professions,
                        profession_ids,
                        recordUrl: id ? (pid ? `/record?profession_id=${pid}&user_id=${id}` : `/record?user_id=${id}`) : '',
                    }
                })

                /**
                 * 2) Группы услуг (табы)
                 */
                await this.loadGroups();

                this.filterGroupsBySpecialists();

                /**
                 * 3) После рендера слайдов:
                 * - дорисовываем табы
                 * - обновляем swiper
                 * - инициализируем табы
                 */
                this.$nextTick(() => {

                    this.renderTabs();

                    if (this.swiper) {
                        this.swiper.update();
                        this.swiper.slideTo(0);
                    }

                    this.initTabs();

                });

            } catch (e) {
                console.error('[Specialists] getSpecialists failed', e);
            } finally {
                this.loading = false;
            }
        },

        async loadGroups() {
            try {
                const url = window.appConfig?.routes?.getServiceGroups;

                if (!url) {
                    this.groups = [];
                    return;
                }

                const response = await fetch(url, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({page: 1, limit: 200}),
                });

                if (!response.ok) {
                    this.groups = [];
                    return;
                }

                const json = await response.json();
                this.groups = Array.isArray(json?.data) ? json.data : [];

            } catch (e) {
                console.error('[Specialists] loadGroups failed', e);
                this.groups = [];
            }
        },

        renderTabs() {
            const root = this.$el;
            const ul = root.querySelector('.tabs__filter');

            if (!ul) {
                console.warn('[Specialists] .tabs__filter not found');
                return;
            }

            /**
             * Удаляем ранее дорисованные табы
             */
            const old = Array.from(ul.querySelectorAll('.tab__link[data-dynamic="1"]'));
            old.forEach(el => el.remove());

            /**
             * Дорисовываем новые
             */
            (this.groups || []).forEach(g => {

                const id = Number(g?.id) || 0;
                const title = String(g?.title || '').trim();

                if (id <= 0 || !title) return;

                const li = document.createElement('li');
                li.className = 'tab__link';
                li.setAttribute('data-tab', `tab-g-${id}`);
                li.setAttribute('data-dynamic', '1');
                li.textContent = title;

                ul.appendChild(li);
            });
        },

        getAvatarUrl(avatar) {
            const a = (avatar || '').trim();

            if (!a) return this.plugImage;

            if (a.startsWith('http://') || a.startsWith('https://')) return a;

            const base = (this.baseUrl || '').replace(/\/+$/, '');
            const path = a.startsWith('/') ? a : `/${a}`;

            return base ? `${base}${path}` : path;
        },

        onAvatarError(e) {
            const img = e?.target;
            if (!img) return;

            if (img.dataset.fallbackApplied === '1') return;

            img.dataset.fallbackApplied = '1';
            img.src = this.plugImage;
        },

        initSwiper() {
            const root = this.$el;
            const slider = root.querySelector('.specialistsSlider');
            const nextEl = root.querySelector('.slider__top-next');
            const prevEl = root.querySelector('.slider__top-prev');

            if (!slider) {
                console.warn('[Specialists] .specialistsSlider not found');
                return;
            }

            this.swiper = new Swiper(slider, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: {nextEl, prevEl},
                breakpoints: {
                    576: {slidesPerView: 2},
                    768: {slidesPerView: 3},
                    1024: {slidesPerView: 4},
                },
            });
        },

        initTabs() {
            /**
             * Не инициализируем повторно
             */
            if (this.tabsInited) {

                const root = this.$el;
                const current = root.querySelector('.tabs__filter .tab__link.current');
                const tabId = current?.dataset?.tab || 'tab-all'

                this.applyTabFilter(tabId);

                return;
            }

            this.tabsInited = true;

            const root = this.$el;
            const tabs = Array.from(root.querySelectorAll('.tabs__filter .tab__link'));

            /**
             * Клик по табу
             */
            tabs.forEach(t => {
                t.addEventListener('click', () => {
                    const tabId = t.dataset.tab || 'tab-all';
                    this.setActiveTab(tabId);
                });
            });

            /**
             * Стартовый таб
             */
            this.setActiveTab('tab-all');
        },

        setActiveTab(tabId) {
            const root = this.$el;
            const tabs = Array.from(root.querySelectorAll('.tabs__filter .tab__link'));

            tabs.forEach(t => t.classList.toggle('current', t.dataset.tab === tabId));

            this.applyTabFilter(tabId);
        },

        applyTabFilter(tabId) {
            const root = this.$el;
            const slides = Array.from(root.querySelectorAll('.swiper-wrapper .swiper-slide'));

            /**
             * tab-all = показываем все слайды
             */
            if (tabId === 'tab-all') {

                slides.forEach(s => {
                    s.style.display = '';
                });

                if (this.swiper) {
                    this.swiper.update();
                    this.swiper.slideTo(0);
                }

                return;
            }

            /**
             * обычный фильтр по tab-g-<id>
             */
            slides.forEach(s => {
                const tabAttr = (s.getAttribute('data-tab') || '').trim();
                const ok = tabAttr.split(/\s+/).includes(tabId);
                s.style.display = ok ? '' : 'none';
            });

            if (this.swiper) {
                this.swiper.update();
                this.swiper.slideTo(0);
            }
        },

        formatPrice(price) {
            if (window.globalState?.formatPrice) return window.globalState.formatPrice(price)
            return String(Number(price) || 0)
        },

        filterGroupsBySpecialists() {
            const usedProfessionIds = new Set();

            this.specialists.forEach((specialist) => {

                (specialist.profession_ids || [])
                    .forEach((id) => {
                        usedProfessionIds.add(Number(id));
                    });

            });

            this.groups = (this.groups || [])
                .filter((group) => {
                    return usedProfessionIds.has(
                        Number(group.id)
                    );
                });
        },
    },

    mounted() {
        this.initSwiper();
        this.getSpecialists();
    },
};

window.SpecialistsServicesComponent = SpecialistsServicesComponent;